import * as types from '../actions/types'
import Immutable from 'immutable'

const INITIAL_STATE = Immutable.fromJS({
    passwordactual: '',
    passwordnuevo: '',
    verificacion: '',
})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.MODIFICAR_INPUTS_CAMBIO_CONTRASENA:
            state = state.set(action.payload.path, action.payload.value)
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/cambiarcontrasena.js